// extracted by mini-css-extract-plugin
export default {"swiper_box":"CategoriesRow_swiper_box__S610v","swiperSlide":"CategoriesRow_swiperSlide__LqlvD"};